"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthersContractWrapperBuilder = void 0;
var RedStonePriceFeed_1 = require("../../connector/impl/RedStonePriceFeed");
var EthersContractWrapper_1 = require("../EthersContractWrapper");
var EthersContractWrapperLite_1 = require("../EthersContractWrapperLite");
var EthersContractWrapperBuilder = /** @class */ (function () {
    function EthersContractWrapperBuilder(baseContract, wrapperType) {
        this.baseContract = baseContract;
        this.wrapperType = wrapperType;
    }
    EthersContractWrapperBuilder.prototype.usingPriceFeed = function (dataFeedId, opts) {
        if (opts === void 0) { opts = {}; }
        var priceFeedConnector = new RedStonePriceFeed_1.RedStonePriceFeed(dataFeedId, opts);
        return this.wrapperType === "full"
            ? new EthersContractWrapper_1.EthersContractWrapper(this.baseContract, priceFeedConnector).finish()
            : new EthersContractWrapperLite_1.EthersContractWrapperLite(this.baseContract, priceFeedConnector).finish();
    };
    return EthersContractWrapperBuilder;
}());
exports.EthersContractWrapperBuilder = EthersContractWrapperBuilder;
//# sourceMappingURL=EthersContractWrapperBuilder.js.map